import { Component, Input, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { BackOfficeService } from '../../../../services/backoffice.service';
import { Subscription, Subject, takeUntil } from 'rxjs';
import { MyConfigOrganization } from '../../../../models/myConfig';
import { BackOffice24StatesService } from '../state/back-office24-states.service';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-problem-flights-list',
  standalone: false,
  templateUrl: './problem-flights-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './problem-flights-list.component.css'
})
export class ProblemFlightsListComponent implements OnInit, OnDestroy {
  isLoading = true;
  @Input() organization: MyConfigOrganization;
  private orgSubscription: Subscription = new Subscription();
  problemFlightsDataSource = new MatTableDataSource<any>([]);
  componentDestroyed$: Subject<boolean> = new Subject();
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] = ['orderNr', 'problemType', 'code', 'scheduled', 'estimated'];
  emptyData = new MatTableDataSource([{ empty: "row" }]);

  constructor(
    public router: Router,
    private backOffice24StatesService: BackOffice24StatesService,
    private backOfficeService: BackOfficeService
  ) { }

  ngOnInit(): void {
    this.orgSubscription = this.backOffice24StatesService.currentOrganization$.subscribe(
      org => {
        this.organization = org;
        if (this.organization?.config?.handleFlights) {
          this.testProblemOrders(this.organization.organizationId || 'a848ccd3-fd8d-4035-925e-571ebb4e93e8');
        }
      }
    );
  }

  private decodeProblemFlags(problemtype: number): string[] {
    const flags = {
      1: 'DepartureFlightCanceled',
      2: 'ArrivalFlightCanceled',
      4: 'DepartureFlightDelayed',
      8: 'ArrivalFlightDelayed'
    };

    const problems: string[] = [];
    Object.entries(flags).forEach(([flag, name]) => {
      if ((problemtype & parseInt(flag)) !== 0) {
        problems.push(name);
      }
    });
    return problems;
  }

  testProblemOrders(organizationId: string) {
    this.isLoading = true;
    this.backOfficeService.getProblemOrders(organizationId).pipe(takeUntil(this.componentDestroyed$))
      .subscribe({
        next: (ProblemOrders) => {
          let problemsData = [];
          ProblemOrders.orders.forEach((order: any) => {
            if (order?.status !== 64) {
              const problems = this.decodeProblemFlags(order.problemtype);

              problems.forEach(problem => {
                if (problem.includes('Arrival')) {
                  problemsData.push({
                    orderId: order.orderId,
                    orderNr: order.orderNumber,
                    problemType: `FLIGHT.PROBLEM_TYPES.${problem}`,
                    code: order.arrival?.arrivalCode,
                    scheduled: order.arrival?.scheduledArrival,
                    estimated: order.arrival?.estimatedArrival,
                    icon: "flight_land"
                  });
                } else if (problem.includes('Departure')) {
                  problemsData.push({
                    orderId: order.orderId,
                    orderNr: order.orderNumber,
                    problemType: `FLIGHT.PROBLEM_TYPES.${problem}`,
                    code: order.departure?.departureCode,
                    scheduled: order.departure?.scheduledDeparture,
                    estimated: order.departure?.estimatedDeparture,
                    icon: "flight_takeoff"
                  });
                }
              });
            }
          });
          this.problemFlightsDataSource.data = problemsData;
          this.problemFlightsDataSource.sort = this.sort;
          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Error fetching problem orders:', error);
        }
      });
  }

  goToOrder(orderId: string): void {
    if (orderId) {
      const url = this.router.serializeUrl(this.router.createUrlTree([`/admin/back-office24-order/${orderId}`]));
      window.open(url, '_blank');
    }
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
    this.orgSubscription.unsubscribe();
  }

}
